import { toast } from 'react-toastify'
import Message from '../../../config/message_v2.js'
import MessageV1 from '../../../config/message.js';

export default {
  validateFile(file) {
    var re = /(\.csv)$/i;
    return re.test(file);
  },
  validateForm(form){
    if(!this.validateFile(form)){
      toast.warning(Message.ERROR.INVALID.FILE_TYPE)
      return false
    }
    return true
  },
  validateSite(form){
    if(form.site.value.trim() === ""){
      toast.warning(MessageV1.ERROR.MODEL.TRACKING.FORM.VALIDATION.SITE_EMPTY)
      return false
    }else if(form.location.value.trim() === ""){
      toast.warning(MessageV1.ERROR.MODEL.TRACKING.FORM.VALIDATION.LOCATION_EMPTY)
      return false
    }
    return true
  },
}



// WEBPACK FOOTER //
// ./src/App/master/import/helper/form.js